const RemoveClausesIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0001 5V6.66667H6.66675V10H8.33341V31.6667C8.33341 32.5507 8.6846 33.3986 9.30973 34.0237C9.93485 34.6488 10.7827 35 11.6667 35H28.3334C29.2175 35 30.0653 34.6488 30.6904 34.0237C31.3156 33.3986 31.6667 32.5507 31.6667 31.6667V10H33.3334V6.66667H25.0001V5H15.0001ZM11.6667 10H28.3334V31.6667H11.6667V10ZM15.0001 13.3333V28.3333H18.3334V13.3333H15.0001ZM21.6667 13.3333V28.3333H25.0001V13.3333H21.6667Z"
        fill="#A5A5A5"
      />
    </svg>
  );
};

export default RemoveClausesIcon;
